import React, { useState } from "react";
import { Box } from "@mui/material";
import { Add } from "@mui/icons-material";

import { PageLayout } from "../../layouts/PageLayout";
import { AddEditSubContractor, SubcontractorList, SubcontractorOverview } from "../../components/subcontractor";
import { PageHeader } from "../../components/v3";
import { CREATE_SUBCONTRACTOR, VIEW_SUBCONTRACTOR_ANALYTICS } from "../../constants";
import { useHasPermission } from "../../utils";

export const SubContractors = () => {
  const [totalCount, setTotalCount] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [reload, setReload] = useState(0);

  const hasAddSubcontractor = useHasPermission(CREATE_SUBCONTRACTOR);
  const hasViewAnalytics = useHasPermission(VIEW_SUBCONTRACTOR_ANALYTICS);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleReload = () => setReload((prev) => prev + 1);

  // Check if the user has permission to create subcontractor
  const buttons = [
    hasAddSubcontractor && {
      buttonText: "Add Subcontractor",
      buttonIcon: Add,
      onClick: handleOpenModal,
    },
  ];

  return (
    <>
      <PageLayout>
        {/* header section */}
        <PageHeader
          // title
          title="Subcontractors"
          subtitle={`${totalCount} Subcontractors`}
          buttons={buttons}
        />

        {hasViewAnalytics ? (
          <>
            <Box sx={{ position: "relative", height: 40 }}>
              <SubcontractorOverview />
            </Box>
            <SubcontractorList totalCount={totalCount} setTotalCount={setTotalCount} reloadData={reload} />
          </>
        ) : (
          <Box sx={{ mt: -9, position: "relative", zIndex: 2 }}>
            <SubcontractorList totalCount={totalCount} setTotalCount={setTotalCount} reloadData={reload} />
          </Box>
        )}
      </PageLayout>

      {/* add subcontractor modal */}
      <AddEditSubContractor open={openModal} onClose={handleCloseModal} onSuccess={handleReload} />
    </>
  );
};
